import type {ImageField, PrismicDocument} from '@prismicio/types';

type SeoData = {
    metaDescription?: string;
    metaTitle?: string;
    openGraphTitle?: string;
    openGraphDescription?: string;
    openGraphImage?: ImageField;
    twitterAccount?: string;
    noIndex?: boolean;
};

function getLocaleWithCorrectFormat(locale?: string) {
    return locale?.replace('_', '-') ?? 'en';
}

function makeHeadMetaData(document?: PrismicDocument<SeoData>, locale?: string) {
    if (!document) {
        return {
            htmlAttrs: {
                lang: getLocaleWithCorrectFormat(locale),
            },
        };
    }
    return {
        title: document.data.metaTitle ?? 'Malt',
        htmlAttrs: {
            lang: getLocaleWithCorrectFormat(locale),
        },
        meta: [
            {
                name: 'description',
                content: document.data.metaDescription ?? 'Malt',
            },
            {
                property: 'og:title',
                content: document.data.openGraphTitle ?? '',
            },
            {
                property: 'og:description',
                content: document.data.openGraphDescription ?? '',
            },
            {
                property: 'og:image',
                content: document.data.openGraphImage?.url ?? '',
            },
            {
                property: 'og:type',
                content: 'website',
            },
            {
                property: 'twitter:creator',
                content: document.data.twitterAccount ?? '',
            },

            ...(document.data.noIndex
                ? [
                      {
                          name: 'robots',
                          content: 'noindex',
                      },
                  ]
                : []),
        ],
    };
}

export function buildHeadMetadata(document?: PrismicDocument<SeoData>, locale?: string) {
    return makeHeadMetaData(document, locale);
}
